import React, { forwardRef, useContext, useImperativeHandle, useState } from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import AddCircle from '@mui/icons-material/AddCircle';
import Cancel from '@mui/icons-material/Cancel';
import Autocomplete from '@mui/material/Autocomplete';
import { UserTypeContext } from '../../AppRoute'
import configJSON from "../../Config.json";
import {
    NotificationContainer,
    NotificationManager,
} from "react-notifications";
import assignRecruiterRequisition from '../../apis/assignRecruiterRequisition/assignRecruiterRequisition'
import checkRequisitionExists from '../../apis/checkRequisitionExists/checkRequisitionExists'
import { reassignRecruiter } from '../../apis/assignRecruiter/assignRecruiter'
import getRecruiterByTeam from '../../apis/getRecruitersByTeam/getRecruiterByTeam'
import getAllTeamByOrgId from '../../apis/teambyOrganizationId/getAllTeamByOrgId'
import { useLocation } from 'react-router-dom'
import "./teamLeaderRequisitionAssignment.css";
import RecruiterReassignmentModel from "../recruiterreassignmentmodel/recruiterreassignmentmodel"

const RecruiterRequisitionAssignment = forwardRef((props, ref) => {
    const location = useLocation();
    const { userType, userRecords } = useContext(UserTypeContext);
    const userRecruitmentpartnerId = userType === 'Admin' ? location?.state?.recruitmentPartnerId : userRecords?.recruitmentpartnerId;
    const { recruiterModalIsOpen, requisitionResponseData, closeRecruiterRequisitionModal, setRecruiterModalIsOpen, status, getRequisitionDetail, selectedTeam } = props
    const idContextTest = userType === "Admin" ? location?.state?.id : userRecords?.id
    const [recruiterAssignment, setRecruiterAssignment] = useState([])
    const [recruiterOptions, setRecruiterOptions] = useState([])
    const [isUserDataUpdating, setIsUserDataUpdating] = useState(false)
    const [isReassignModelOpen, setIsReassignModelOpen] = useState(false)
    const [reAssignmentObj, setReAssignmentObj] = useState({
        reassginedFrom: {},
        reassginedTo: {},
        reassignTeam: {},
        isReassignTeamFetching: false,
        isReassignToOptionFetching: false

    })
    const [reassignRecruiterList, setReassignRecruiterList] = useState([])
    const [reassignToRecruiterList, setReassignToRecruiterList] = useState([])
    const [reassignTeamList, setReassignTeamList] = useState([])
    const [recruiterDataArray, setRecruiterDataArray] = useState([])


    const addRecruiterAssigment = () => {

        let assignedRecruiters = [];
        if (userType === "Team Leader" || userType === "Recruiter") {
            assignedRecruiters = requisitionResponseData?.recruiterRequisitionDetails || [];
        }
        else if (userType === "MIS Operator" || userType === "Organization Admin" || userType === "Recruitment Leader") {
            assignedRecruiters = requisitionResponseData?.recruiterRequisitionDetails || [];
            assignedRecruiters = assignedRecruiters.filter(item => item.team.teamId === selectedTeam._id)
        }

        if (assignedRecruiters.length > 0) {
            let arr = [];
            // let defaultTeamData = selectedTeam
            let recruiterDetailsData = requisitionResponseData?.recruiterDetails || [];
            assignedRecruiters.forEach(item => {
                arr.push({
                    team: getDefaultTeamData(),
                    recruiter: recruiterDetailsData.find(val => val.id === item.recruiterId),
                    recruiterOptionFetching: false,
                    noOfPositions: item.no_of_positions
                })
            })
            setRecruiterAssignment(arr)
        }
        else {
            addRecruiterAssigmentRow();
        }
    }

    const addRecruiterAssigmentRow = () => {
        setRecruiterAssignment([...recruiterAssignment,
        {
            team: getDefaultTeamData(),
            recruiter: {},
            recruiterOptionFetching: false,
            noOfPositions: ""
        }])
    }

    const getDefaultTeamData = () => {

        let teamData = {}

        if (userType === "Team Leader") {
            let teamLeaderRequistionRefData = requisitionResponseData?.teamLeaderRequisitionDetails || [];
            teamLeaderRequistionRefData = teamLeaderRequistionRefData.find(item => item.team.teamLeaderId === userRecords.id);
            teamData = teamLeaderRequistionRefData?.teamDetails;
        }
        else if (userType === "MIS Operator" || userType === "Organization Admin" || userType === "Recruitment Leader") {
            teamData = selectedTeam;
        }
        return teamData;

    }

    const extraRecruiterAssignmentClose = async (index) => {
        let originalData = [...recruiterAssignment];
        let defaultTeam = getDefaultTeamData();

        let payload = {
            validation: "RecruiterCandidateRequisition",
            recruiterId: originalData[index]?.recruiter?.id,
            requisitionDetailId: requisitionResponseData?._id,
            recruitmentpartnerId: userRecruitmentpartnerId,
            teamId: defaultTeam?._id,
        }
        let havingAssignedCandidates = false;
        try {
            if (payload.recruiterId) {
                let response = await checkRequisitionExists(payload);
                if (response.status === 200) {
                    let assignedCandidates = response?.data?.data[0]?.candidateRequisitions || [];
                    if (assignedCandidates.length > 0) {
                        assignedCandidates = assignedCandidates.filter(item => item.isActive === true);
                        if (assignedCandidates.length > 0) {
                            havingAssignedCandidates = true;
                            NotificationManager.error("Recruiter already having some assigned candidates for this requisition", "Error", 10000);
                            return;
                        }
                    }
                }
                else {
                    NotificationManager.error("Error in fetching recruiter's assigned candidate data", "Error", 10000);
                    return;
                }
            }
            if (!havingAssignedCandidates) {
                originalData.splice(index, 1);
                setRecruiterAssignment(originalData);
            }
        } catch (error) {
            NotificationManager.error("Something went wrong", "Error", 10000);
        }
    }

    const clearRecruiterRequistionData = () => {
        setRecruiterAssignment([]);
    }

    const getRecruiterOptions = (recruitersData) => {
        let recruiterOptionsData = [];

        recruitersData.forEach(item => {
            const assignedRecruiters = recruiterAssignment.filter(val => val.recruiter.id === item.id);
            if (assignedRecruiters.length === 0) {
                recruiterOptionsData.push(item);
            }
        });

        return recruiterOptionsData;
    }

    const getRemovedRecruiterIds = () => {
        let removedRecruiterIds = [];
        let notificationList = [];
        let recruiterLogList = [];
        let allRecruiterAssignmentData = requisitionResponseData?.recruiterRequisitionDetails || [];
        let teamData = getDefaultTeamData();
        allRecruiterAssignmentData = allRecruiterAssignmentData.filter(item => item.team.teamId === teamData._id)
        if (allRecruiterAssignmentData.length) {
            allRecruiterAssignmentData.forEach((item) => {
                let noOfPositions;
                let isExist = recruiterAssignment.some((assignment) => {
                    if (assignment.recruiter?.id === item.recruiterId) {
                        noOfPositions = parseInt(assignment.noOfPositions) // Store the position when isExist is true
                        return true;  // Return true to indicate that the recruiter exists
                    }
                    return false;  // Return false if recruiter doesn't match
                });
                if (!isExist) {
                    removedRecruiterIds.push(item?.recruiterId);
                    const tlobj = {}
                    tlobj.id = item?.recruiterId;
                    tlobj.email = item?.email;
                    tlobj.displayName = item?.displayName;
                    // tlobj.message = "Requisition with Reference ID : " + requisitionResponseData.reqreferenceId + " " + " is reassigned by " + displayName;
                    tlobj.status = -1 //
                    notificationList.push(tlobj)
                } else {
                    if (item?.no_of_positions !== noOfPositions) {
                        const tlobj = {}
                        tlobj.id = item?.recruiterId;
                        tlobj.email = item?.email;
                        tlobj.displayName = item?.displayName;
                        // tlobj.message = "Requisition with Reference ID : " + requisitionResponseData.reqreferenceId + " " + " is reassigned by " + displayName;
                        tlobj.status = 1 //already added
                        notificationList.push(tlobj);
                        recruiterLogList.push(item?.recruiterId);
                    }

                }
            });
            const newTlList = recruiterAssignment.filter(item2 => !allRecruiterAssignmentData.some(item1 => item1?.recruiterId === item2.recruiter?.id));
            newTlList.forEach((item) => {
                const tlobj = {}
                tlobj.id = item?.recruiter?.id;
                tlobj.email = item?.recruiter?.email;
                tlobj.displayName = item?.recruiter?.displayName;
                // tlobj.message = "Requisition with Reference ID : " + requisitionResponseData.reqreferenceId + " " + " is reassigned by " + displayName;
                tlobj.status = 0 //newly added
                notificationList.push(tlobj);
                recruiterLogList.push(item?.recruiter?.id);
            })
        } else {
            recruiterAssignment.forEach((item) => {
                const tlobj = {}
                tlobj.id = item?.recruiter?.id;
                tlobj.email = item?.recruiter?.email;
                tlobj.displayName = item?.recruiter?.displayName;
                // tlobj.message = "Requisition with Reference ID : " + requisitionResponseData.reqreferenceId + " " + " is reassigned by " + displayName;
                tlobj.status = 0  ////newly added
                notificationList.push(tlobj);
                recruiterLogList.push(item?.recruiter?.id);
            })
        }
        return { "removedRecruiterIds": removedRecruiterIds, "notificationList": notificationList, "recruiterLogList": recruiterLogList };
    }


    const fetchRecruiterOptions = async (item, index) => {
        let oldRecruiterArray = [...recruiterAssignment];
        const oldRecruiterEmails = oldRecruiterArray
            ?.map(r => r.recruiter?.email)
            .filter(Boolean);
        setRecruiterAssignment(oldRecruiterArray);
        if (recruiterOptions.length !== 0) {
            const filteredRecruiters = recruiterDataArray?.filter(
                recruiter => !oldRecruiterEmails.includes(recruiter.email)
            );
            setRecruiterOptions(filteredRecruiters);
        }
        else {
            let teamId = item?.team?._id;
            oldRecruiterArray[index].recruiterOptionFetching = true;
            try {
                let response = await getRecruiterByTeam(teamId);
                let recruiterData = response?.data.data[0]?.recruiterDetails
                setRecruiterDataArray(recruiterData)
                oldRecruiterArray[index].recruiterOptionFetching = false;
                let filteredData = getRecruiterOptions(recruiterData);
                setRecruiterOptions(filteredData);
                setRecruiterAssignment(oldRecruiterArray);
            } catch (error) {
                NotificationManager.error("Error in fetching recruiter options", "Error", 10000);
            }
        }
    }

    const recruiterChangeHandler = async (value, index) => {

        try {
            let oldRecruiterArray = [...recruiterAssignment];
            let recruiterData = oldRecruiterArray[index].recruiter;
            let havingAssignedCandidates = false;
            let defaultTeam = getDefaultTeamData();


            let payload = {
                validation: "RecruiterCandidateRequisition",
                recruiterId: recruiterData.id,
                requisitionDetailId: requisitionResponseData?._id,
                recruitmentpartnerId: userRecruitmentpartnerId,
                teamId: defaultTeam._id
            }

            let response = await checkRequisitionExists(payload);

            if (response.status === 200) {
                if (response?.data?.data[0]?.candidateRequisitions?.length > 0) {
                    havingAssignedCandidates = true;
                    NotificationManager.error("The recruiter has already started his work for this requisition", "Error", 10000);
                    return;
                }
            }
            else {
                NotificationManager.error("Error in fetching recruiter data", "Error", 10000);
                return;
            }

            if (!havingAssignedCandidates) {

                if (value) {
                    oldRecruiterArray[index].recruiter = value;
                    openingHandleChange({ target: { value: getPositionsTobeAssigned() } }, index);
                }
                else {
                    oldRecruiterArray[index].recruiter = {};
                }
                setRecruiterAssignment(oldRecruiterArray);
            }
            else {
                setRecruiterAssignment(oldRecruiterArray);
            }
        } catch (error) {
            NotificationManager.error("Something went wrong", "Error", 10000);
        }
    }

    const openingHandleChange = (e, index) => {
        let oldRecruiterArray = [...recruiterAssignment];
        if (e.target.value) {
            oldRecruiterArray[index].noOfPositions = parseInt(e.target.value);
        }
        else {
            oldRecruiterArray[index].noOfPositions = "";
        }
        setRecruiterAssignment(oldRecruiterArray);
    }

    const handleAssignRecruiter = async () => {
        if (isUserDataUpdating) return;
        setIsUserDataUpdating(true);
        setRecruiterOptions([])
        let isvalid = true;
        let totalassignedPositions = 0;
        let errorMessage = "";
        let recruiterAssignmentData = [...recruiterAssignment];
        const openStatus = status.find(item => item.statusCode === configJSON?.requisitionStatusCodes?.OPEN);
        for (let i = 0; i < recruiterAssignmentData.length; i++) {
            let item = recruiterAssignmentData[i];

            if (Object.keys(item.team).length === 0 || Object.keys(item.recruiter).length === 0 || item.noOfPositions === "") {
                isvalid = false;
                errorMessage = "Please fill all the fields";
                setIsUserDataUpdating(false);
                break;
            }
            else if (item.noOfPositions <= 0) {
                isvalid = false;
                errorMessage = "Positions should be greater than 0";
                setIsUserDataUpdating(false);
                break;
            }
            try {
                let payloadData = {
                    validation: "RecruiterFilledCandidates",
                    recruiterId: item?.recruiter?.id,
                    requisitionDetailId: requisitionResponseData?._id,
                    recruitmentpartnerId: userRecruitmentpartnerId
                }
                let response = await checkRequisitionExists(payloadData);
                if (response.status === 200) {
                    if (response.data.data[0]?.candidateRequisitions?.length > item.noOfPositions) {

                        let candidateCount = response.data.data[0]?.candidateRequisitions?.length;
                        NotificationManager.error(
                            `Recruiter (${item?.recruiter?.email}) already has ${candidateCount} candidates as selected or started. Assigned positions cannot be fewer than ${candidateCount}`,
                            "Error",
                            10000
                        );
                        isvalid = false;
                        setIsUserDataUpdating(false);
                        break;
                    }
                    else if (response.data.data[0]?.candidateRequisitions?.length === item.noOfPositions) {
                        const subStatus_covered = openStatus?.subList?.find(item => item.subCode === configJSON?.requisitionStatusCodes?.OPENSUBSTATUS?.COVERED);
                        recruiterAssignmentData[i].status = {
                            subCode: subStatus_covered.subCode,
                            statusCode: openStatus.statusCode,
                            statusCodeId: openStatus._id,
                            subCodeId: subStatus_covered._id
                        }
                    }
                    else if (response.data.data[0]?.candidateRequisitions?.length < item.noOfPositions) {
                        const subStatus_uncovered = openStatus?.subList?.find(item => item.subCode === configJSON?.requisitionStatusCodes?.OPENSUBSTATUS?.UNCOVERED);
                        recruiterAssignmentData[i].status = {
                            subCode: subStatus_uncovered.subCode,
                            statusCode: openStatus.statusCode,
                            statusCodeId: openStatus._id,
                            subCodeId: subStatus_uncovered._id
                        }
                    }
                    else {
                        const subStatus_uncovered = openStatus?.subList?.find(item => item.subCode === configJSON?.requisitionStatusCodes?.OPENSUBSTATUS?.UNCOVERED);
                        recruiterAssignmentData[i].status = {
                            subCode: subStatus_uncovered.subCode,
                            statusCode: openStatus.statusCode,
                            statusCodeId: openStatus._id,
                            subCodeId: subStatus_uncovered._id
                        }
                    }
                }
            } catch (error) {
                NotificationManager.error("Error in fetching recruiter's assigned candidates", "Error", 10000);
                setIsUserDataUpdating(false);
            }
            totalassignedPositions = Math.max(totalassignedPositions, parseInt(item.noOfPositions));
        }

        let recLeadObj = getRemovedRecruiterIds();
        let removedRecruiterIds = recLeadObj.removedRecruiterIds;

        if (removedRecruiterIds.length > 0 || recruiterAssignmentData.length > 0) {

            let totalPositions = getPositionsTobeAssigned();
            if (totalassignedPositions > totalPositions) {
                isvalid = false;
                setIsUserDataUpdating(false);
                return NotificationManager.error(`Total assigned positions should not be greater than ${totalPositions}`, "Error", 10000);
            }

            if (isvalid) {
                let teamLeaderRequisitionIds = []
                let payloadObj = [];
                for (let i = 0; i < recruiterAssignmentData.length; i++) {
                    let teamLeaderRequistionReference = requisitionResponseData?.teamLeaderRequisitionDetails?.find(val => val.team.teamId === recruiterAssignmentData[i]?.team?._id)
                    teamLeaderRequisitionIds.push(teamLeaderRequistionReference?._id)
                    let obj = {
                        requisitionId: requisitionResponseData?.requisitionId,
                        requisitionDetailId: requisitionResponseData?._id,
                        requisitionLeaderId: requisitionResponseData?.recruiterLeaderRequisitionDetails?._id,
                        requisitionTeamLeaderId: teamLeaderRequistionReference?._id,
                        recruiterId: recruiterAssignmentData[i]?.recruiter?.id,
                        isBorrowed: teamLeaderRequistionReference?.isBorrowed,
                        isBorrowedExternally: teamLeaderRequistionReference?.isBorrowedExternally,
                        isBorrowedFromSameDiv: teamLeaderRequistionReference?.isBorrowedFromSameDiv,
                        team: teamLeaderRequistionReference?.team,
                        division: teamLeaderRequistionReference?.division,
                        status: recruiterAssignmentData[i]?.status,
                        isActive: true,
                        no_of_positions: parseInt(recruiterAssignmentData[i]?.noOfPositions)
                    }
                    payloadObj.push(obj)
                }

                let istlnf = userType === "Team Leader" ? false : true
                let teamData = getDefaultTeamData();
                let payload = {
                    recruitersData: payloadObj,
                    teamLeaderRequisitionIds: teamLeaderRequisitionIds,
                    requisitionDetailId: requisitionResponseData._id,
                    recruitmentpartnerId: userRecruitmentpartnerId,
                    removedRecruiterIds: removedRecruiterIds,
                    notificationList: recLeadObj.notificationList,
                    recruiterLogList: recLeadObj.recruiterLogList,
                    senderId: idContextTest,
                    reqreferenceId: requisitionResponseData.reqreferenceId,
                    displayName: userRecords.displayName,
                    // teamLeaderEmail: selectedTeamLeader.email,
                    teamLeaderId: teamData?.teamLeaderId,
                    userRecruitmentpartnerId: userRecruitmentpartnerId,
                    userId: idContextTest,
                    istlnf,
                    requisitionId: requisitionResponseData.requisitionId,
                    teamId: teamData?._id
                }
                try {
                    let response = await assignRecruiterRequisition(payload);
                    if (response.status === 200) {
                        NotificationManager.success(response.data.message, "Success", 10000);
                        setIsUserDataUpdating(false);
                        closeRecruiterRequisitionModal({ action: 'save' });
                        getRequisitionDetail();
                    }
                    else {
                        NotificationManager.error("An unexpected error occurred", "Error", 10000);
                        setIsUserDataUpdating(false);
                    }
                } catch (error) {
                    if (error.response.status === 400) {
                        NotificationManager.error(error?.response?.data?.errMessage, "Error", 10000);
                        setIsUserDataUpdating(false);
                    }
                    else {
                        NotificationManager.error("Error assinging recruiter", "Error", 10000);
                        setIsUserDataUpdating(false);
                    }
                }
            }
            else if (errorMessage !== "") {
                NotificationManager.error(errorMessage, "Error", 10000);
                setIsUserDataUpdating(false);
            }
        }
        else {
            closeRecruiterRequisitionModal({ action: 'save' });
        }
    }

    const getPositionsTobeAssigned = () => {
        let teamLeaderRequistionReference = {}
        if (userType === "Team Leader") {
            let teamDetailsData = getDefaultTeamData();
            teamLeaderRequistionReference = requisitionResponseData?.teamLeaderRequisitionDetails?.find(val => val.team.teamId === teamDetailsData._id)
        }
        else {
            teamLeaderRequistionReference = requisitionResponseData?.teamLeaderRequisitionDetails?.find(val => val.team.teamId === selectedTeam._id)
        }
        return teamLeaderRequistionReference?.no_of_positions
    }

    const openRecruiterReassignModel = () => {
        let arr = recruiterAssignment.map(item => item?.recruiter)
        setReassignRecruiterList(arr);
        setRecruiterModalIsOpen(false);
        setIsReassignModelOpen(true);
    }

    const closeRecruiterReassignModel = () => {
        setReassignRecruiterList([]);
        setReAssignmentObj({ reassginedFrom: {}, reassginedTo: {}, isReassignToOptionFetching: false });
        setRecruiterModalIsOpen(true);
        setIsReassignModelOpen(false);
        setReassignToRecruiterList([]);
    }

    const fromReassignmentChangeHandler = async (value) => {
        let obj = { ...reAssignmentObj };
        if (value) {
            obj.reassginedFrom = value;
            obj.reassginedTo = {};
        }
        else {
            obj.reassginedFrom = {};
            obj.reassginedTo = {};
        }
        setReAssignmentObj(obj);
    }

    const newRecruiterReassignmentChangeHandler = (value) => {
        let obj = { ...reAssignmentObj };
        if (value) {
            obj.reassginedTo = value;
        }
        else {
            obj.reassginedTo = {};
        }
        setReAssignmentObj(obj);
    }

    const reassignmentTeamChangeHandler = (value) => {
        if (value) {
            let recruiterList = value?.recruiter;
            setReAssignmentObj({
                ...reAssignmentObj,
                reassignTeam: value,
                reassginedTo: {}
            })
            recruiterList = recruiterList.filter(item => item.email !== reAssignmentObj.reassginedFrom.email);
            setReassignToRecruiterList(recruiterList || []);
        }
        else {
            setReAssignmentObj({
                ...reAssignmentObj,
                reassignTeam: {},
                reassginedTo: {}
            })
            setReassignToRecruiterList([]);
        }
    }

    const handleReassignment = async () => {
        try {
            if (Object.keys(reAssignmentObj.reassginedFrom).length === 0 || Object.keys(reAssignmentObj.reassginedTo).length === 0) {
                NotificationManager.error("Please fill all the fields", "Error", 10000);
                return;
            }
            else {
                setIsUserDataUpdating(true);
                let istlnf = userType === "Team Leader" ? false : true
                let teamData = getDefaultTeamData();
                let notificationList = [{ "id": reAssignmentObj.reassginedFrom.id, "email": reAssignmentObj.reassginedFrom.email, "displayName": reAssignmentObj.reassginedFrom.displayName, "status": -1 },
                { "id": reAssignmentObj.reassginedTo.id, "email": reAssignmentObj.reassginedTo.email, "displayName": reAssignmentObj.reassginedTo.displayName, "status": 0 }];
                let payloadData = {
                    requisitionDetailId: requisitionResponseData._id,
                    requisitionId: requisitionResponseData.requisitionId,
                    oldRceruiterId: reAssignmentObj.reassginedFrom.id,
                    newRecruiterId: reAssignmentObj.reassginedTo.id,
                    notificationList: notificationList,
                    senderId: idContextTest,
                    reqreferenceId: requisitionResponseData.reqreferenceId,
                    displayName: userRecords.displayName,
                    teamLeaderId: selectedTeam.teamLeaderId,
                    recruitmentpartnerId: userRecruitmentpartnerId,
                    istlnf,
                    teamId: teamData._id,
                    newRecruiterTeamId: userType === "Team Leader" ? teamData._id : reAssignmentObj.reassignTeam._id,
                }

                let payload = {
                    reassignList: [payloadData],
                    userRecruitmentpartnerId: userRecruitmentpartnerId,
                    userId: idContextTest,
                }

                let response = await reassignRecruiter(payload);

                if (response.status === 200) {
                    NotificationManager.success(response.data.message, "Success", 10000);
                    setRecruiterOptions([])
                    setIsUserDataUpdating(false);
                    closeRecruiterReassignModel();
                    closeRecruiterRequisitionModal({ action: 'save' });
                    getRequisitionDetail();
                }
                else {
                    NotificationManager.error("An unexpected error occurred", "Error", 10000);
                    setIsUserDataUpdating(false);
                }
            }
        } catch (error) {
            if (error.response.status === 400) {
                NotificationManager.error(error?.response?.data?.errMessage, "Error", 10000);
                setIsUserDataUpdating(false);
            }
            else {
                NotificationManager.error("Error in reassigning recruiter", "Error", 10000);
            }
        }
    }

    // Used to make the function available to the parent component
    useImperativeHandle(ref, () => ({
        addRecruiterAssigment,
        clearRecruiterRequistionData
    }));



    return (
        <>
            <Dialog
                onClose={() => { closeRecruiterRequisitionModal(); setRecruiterOptions([]) }}
                aria-labelledby="customized-dialog-title"
                open={recruiterModalIsOpen}
                className='dialogBox_assignRequisition'
                maxWidth='xl'
            >
                <DialogTitle id="customized-dialog-title" className="header_teamleaderRequisition" onClose={closeRecruiterRequisitionModal}>
                    <div className='header_top_teamleaderRequisition'>
                        Recruiter Assignment
                    </div>
                </DialogTitle>
                <DialogContent className='assignRequisitionContainer'>
                    {userType !== "Recruiter" ? <div className='positionsTag_assignRecruiter'>Total assigned positions : {getPositionsTobeAssigned()}</div> : ""}
                    <Table>
                        <TableHead>
                            <TableRow>
                                {userType !== "Recruiter" ? <TableCell>Team*</TableCell> : ""}
                                <TableCell>Recruiter Email*</TableCell>
                                <TableCell>Recruiter Name*</TableCell>
                                <TableCell>No of positions*</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {recruiterAssignment.map((item, i) => (
                                <TableRow>
                                    {userType !== "Recruiter" ?
                                        <TableCell>
                                            <FormControl
                                                fullWidth variant="outlined">
                                                <Autocomplete
                                                    id="multiple-limit-tags"
                                                    className='input-text-3'
                                                    options={[item.team]}
                                                    getOptionLabel={(option) =>
                                                        option.teamName ? option?.teamName : ""
                                                    }
                                                    filterSelectedOptions
                                                    disableClearable
                                                    disabled={true}
                                                    value={item.team}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            required={true}
                                                            placeholder="Select Team Leader"
                                                        />
                                                    }
                                                />
                                            </FormControl>
                                        </TableCell>
                                        : null}

                                    <TableCell>
                                        <FormControl
                                            fullWidth variant="outlined">
                                            <Autocomplete
                                                id="multiple-limit-tags"
                                                className='input-text-3'
                                                options={recruiterOptions}
                                                getOptionLabel={(option) =>
                                                    option.email ? option?.email : ""
                                                }
                                                value={item.recruiter}
                                                loading={item.recruiterOptionFetching}
                                                onFocus={(e) =>
                                                    fetchRecruiterOptions(item, i)
                                                }
                                                filterSelectedOptions
                                                disabled={userType === "Recruiter" ? true : false}
                                                onChange={(e, val) => recruiterChangeHandler(val, i)}
                                                renderInput={(params) =>
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        required={true}
                                                        placeholder="Select Recruiter"
                                                    />
                                                }
                                            />
                                        </FormControl>
                                    </TableCell>

                                    <TableCell>
                                        <FormControl fullWidth variant="outlined">
                                            <TextField
                                                id="outlined-basic"
                                                variant="outlined"
                                                placeholder="Recruiter Name"
                                                value={Object.keys(item.recruiter).length > 0 ? item.recruiter.displayName : ""}
                                                disabled={true}
                                                className='recruiterName_teamLeader'
                                            />
                                        </FormControl>
                                    </TableCell>

                                    <TableCell className='openings_RecruiterRequisitionContainer'>
                                        <FormControl variant="filled">
                                            <TextField
                                                id="outlined-basic"
                                                variant="outlined"
                                                type='number'
                                                placeholder="Enter positions"
                                                value={item.noOfPositions}
                                                disabled={userType === "Recruiter" ? true : !(recruiterAssignment[i].team.recruiterId.includes(recruiterAssignment[i].recruiter.id))}
                                                className='recruiterAssignment_teamLeader'
                                                onChange={(e) => openingHandleChange(e, i)}
                                            />
                                        </FormControl>

                                        {userType !== "Recruiter" && (
                                            <Cancel
                                                className="cancelIcon_teamLeaderReq"
                                                onClick={(e) => extraRecruiterAssignmentClose(i, item)}
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}

                            {userType !== "Recruiter" && (
                                <TableRow>
                                    <TableCell colSpan={4}>
                                        <AddCircle
                                            color="primary"
                                            onClick={(e) => addRecruiterAssigmentRow(e)}
                                            className="addIcon_teamLeaderAssignment"
                                        />
                                    </TableCell>
                                </TableRow>)
                            }
                        </TableBody>
                    </Table>

                </DialogContent>

                <DialogActions className="dialog-actionbutton-assignTeamLeader">
                    {(userType === "MIS Operator" || userType === "Organization Admin" || userType === "Recruitment Leader") && (
                        <button className="reassign-button-recruiter" onClick={() => openRecruiterReassignModel()}>
                            Reassignment
                        </button>
                    )}

                    <button className="cancel-button-assignTeamLeader" onClick={() => { closeRecruiterRequisitionModal(); setRecruiterOptions([]) }}>
                        Cancel
                    </button>
                    {userType !== "Recruiter" && (
                        <button
                            className={isUserDataUpdating ? 'updateButton-assignTeamLeader_disabled' : 'updateButton-assignTeamLeader'}
                            onClick={(e) => handleAssignRecruiter()}
                            disabled={isUserDataUpdating}
                        >
                            <span>Save</span>
                            {isUserDataUpdating ? (<CircularProgress className="circularProgress_updateButton" />) : null}
                        </button>)}
                </DialogActions>
            </Dialog>

            {/* i want this dialog to be a component , so that i can reuse it */}

            {/* <Dialog
                onClose={closeRecruiterReassignModel}
                aria-labelledby="customized-dialog-title"
                width='lg'
                fullWidth={true}
                open={isReassignModelOpen}
                className='dialogBox_reassignRecruiter'
            >

                <DialogTitle id="customized-dialog-title" className="header">
                    <div className='header_top'>
                        Recruiter Reassignment
                    </div>
                </DialogTitle>
                <DialogContent className='reassignRecruiterContainer'>
                    <Typography className='label_recruiterReassignment'>Assigned Recruiter *</Typography>
                    <FormControl
                        fullWidth variant="outlined">
                        <Autocomplete
                            id="multiple-limit-tags"
                            className='input-text-3'
                            options={reassignRecruiterList}
                            getOptionLabel={(option) =>
                                option?.email ? option?.email : ""
                            }
                            filterSelectedOptions
                            disableClearable
                            onChange={(e, value) => fromReassignmentChangeHandler(value)}
                            value={reAssignmentObj.reassginedFrom}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    required={true}
                                    placeholder="Select Recruiter"
                                />
                            }
                        />
                    </FormControl>
                    {userType !== "Team Leader" && userType !== "Recruiter" && (
                        <>
                            <Typography className='label_recruiterReassignment'>Choose Team *</Typography>
                            <FormControl
                                fullWidth variant="outlined">
                                <Autocomplete
                                    id="multiple-limit-tags"
                                    className='input-text-3'
                                    options={reassignTeamList}
                                    getOptionLabel={(option) =>
                                        option?.teamName ? option?.teamName : ""
                                    }
                                    filterSelectedOptions
                                    disableClearable
                                    loading={reAssignmentObj.isReassignTeamFetching}
                                    onFocus={(e) => reassignTeamList.length > 0 ? null : null}
                                    onChange={(e, value) => reassignmentTeamChangeHandler(value)}
                                    value={reAssignmentObj.reassignTeam}
                                    disabled={reAssignmentObj.reassginedFrom.id ? false : true}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            required={true}
                                            placeholder="Select Team"
                                        />
                                    }
                                />
                            </FormControl>
                        </>
                    )}

                    <Typography className='label_recruiterReassignment'>Reassign To *</Typography>
                    <FormControl
                        fullWidth variant="outlined">
                        <Autocomplete
                            id="multiple-limit-tags"
                            className='input-text-3'
                            options={reassignToRecruiterList}
                            getOptionLabel={(option) =>
                                option.email ? option?.email : ""
                            }
                            filterSelectedOptions
                            disableClearable
                            loading={reAssignmentObj.isReassignToOptionFetching}
                            onFocus={() => null}
                            onChange={(e, value) => newRecruiterReassignmentChangeHandler(value)}
                            value={reAssignmentObj.reassginedTo}
                            disabled={reAssignmentObj.reassginedFrom.id ? false : true}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    required={true}
                                    placeholder="Select Recruiter"
                                />
                            }
                        />
                    </FormControl>

                    <Typography className='note_recruiterReassignment'>*<b>note: &nbsp;</b>
                        Candidates those are not in "STARTED" stage will be reassigned to a new recruiter.
                    </Typography>
                </DialogContent>


                <DialogActions className="dialog-actionbutton-assignTeamLeader">
                    <button className="cancel-button-assignTeamLeader" onClick={() => closeRecruiterReassignModel()}>
                        Cancel
                    </button>
                    {userType !== "Recruiter" && (
                        <button
                            className={isUserDataUpdating ? 'updateButton-assignTeamLeader_disabled' : 'updateButton-assignTeamLeader'}
                            onClick={(e) => handleReassignment()}
                            disabled={isUserDataUpdating}
                        >
                            <span>Save</span>
                            {isUserDataUpdating ? (<CircularProgress className="circularProgress_updateButton" />) : null}
                        </button>)}
                </DialogActions>

            </Dialog> */}
            <RecruiterReassignmentModel
                open={isReassignModelOpen}
                onClose={closeRecruiterReassignModel}
                onSave={handleReassignment}
                userType={userType}
                isUserDataUpdating={isUserDataUpdating}
                reassignRecruiterList={reassignRecruiterList}
                reassignTeamList={reassignTeamList}
                reassignToRecruiterList={reassignToRecruiterList}
                reAssignmentObj={reAssignmentObj}
                fromReassignmentChangeHandler={fromReassignmentChangeHandler}
                newRecruiterReassignmentChangeHandler={newRecruiterReassignmentChangeHandler}
                reassignmentTeamChangeHandler={reassignmentTeamChangeHandler}
                userRecruitmentpartnerId={userRecruitmentpartnerId}
                selectedTeam={selectedTeam}
            />

            <NotificationContainer />
        </>
    )
})

export default RecruiterRequisitionAssignment